import {ChangeDetectionStrategy, Component, ElementRef, Input, OnInit} from '@angular/core';

@Component({
  selector: 'pl-drag-handle',
  templateUrl: './drag-handle.component.html',
  styleUrls: ['./drag-handle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DragHandleComponent implements OnInit {
  constructor(private elementRef: ElementRef) { }
  ngOnInit(): void { }

  @Input()
  set dragHandleSize(v: number) {
    this.elementRef.nativeElement.style.setProperty('--drag-handle-size', `${v}px`);
  }

  @Input()
  set dragHandleOffset(v: number) {
    this.elementRef.nativeElement.style.setProperty('--drag-handle-offset', `${v}px`);
  }

  @Input()
  set dragHandleColor(v: string) {
    this.elementRef.nativeElement.style.setProperty('--drag-handle-color', v);
  }
}
